import Debug from "debug";
const debug = Debug("cookies");
export function parseMaxAge(value) {
    switch (typeof value) {
        case "string":
            return value.split(/\s/).reduce((acc, str) => {
                let scale = 1;
                if (str.endsWith("y")) {
                    scale = 60 * 60 * 24 * 365;
                }
                else if (str.endsWith("d")) {
                    scale = 60 * 60 * 24;
                }
                else if (str.endsWith("h")) {
                    scale = 60 * 60;
                }
                else if (str.endsWith("m")) {
                    scale = 60;
                }
                acc += parseInt(str, 10) * scale;
                return acc;
            }, 0);
        case "number":
            return value;
        default:
            throw new Error("Invalid value for max-age");
    }
}
export function setCookie(name, value, options = {}) {
    const attributes = [];
    attributes.push(name + "=" + value);
    if (options.maxAge !== undefined) {
        attributes.push("max-age=" + parseMaxAge(options.maxAge));
    }
    if (options.path) {
        attributes.push("path=" + options.path);
    }
    if (options.domain) {
        attributes.push("domain=" + options.domain);
    }
    if (options.secure || (location.protocol === "https:" && options.secure !== false)) {
        attributes.push("secure");
    }
    const cookieValue = attributes.join("; ");
    debug("Setting cookie: %s", cookieValue);
    document.cookie = cookieValue;
}
export function getCookie(name) {
    const value = document.cookie.split(";").filter((value) => value.trim().startsWith(name + "="))[0];
    return value && value.split("=")[1];
}
